import { FC, ReactNode, createContext, useContext, useState } from "react";

interface User {
  role: string;
  permissions: string[];
}

interface AuthContextProps {
  user: User;
  hasPermission: (permission: string) => boolean;
}

interface AuthProviderProps {
  children: ReactNode;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
  const [user, setUser] = useState<User>({
    role: "ADMIN",
    permissions: ["REGISTER_EVENT", "UPDATE_EVENT", "DELETE_USER"],
  });

  const hasPermission = (permission: string) =>
    user.permissions.includes(permission);

  return (
    <AuthContext.Provider value={{ user, hasPermission }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
